/* rm-gallery-swipe.js
   Mobiele swipe voor de custom PDP-galerijen (Bekend van concept).
   Bouwt van de bestaande thumbnails een swipebare scroll-track binnen .hero-img,
   als NAADLOZE loop: voorbij de laatste foto begint hij weer bij de eerste en
   andersom (kloon van laatste vooraan, kloon van eerste achteraan, plus een
   onzichtbare terugsprong zodra je op een kloon landt).
   Werkt naast de bestaande thumbnail-klik: tikken en swipen samen.
   Alleen <= 749px zichtbaar (via rm-gallery-swipe.css). Additief, raakt de
   bestaande sectie-scripts niet aan. Geen em-dashes (huisstijl). */
(function () {
  'use strict';

  function build(gallery) {
    if (gallery.getAttribute('data-rm-swipe') === '1') return;

    var hero = gallery.querySelector('.hero-img');
    var thumbWrap = gallery.querySelector('.thumbs');
    if (!hero || !thumbWrap) return;

    var heroImg = hero.querySelector('#heroImg') || hero.querySelector('img');
    var thumbs = Array.prototype.slice.call(thumbWrap.querySelectorAll('.thumb[data-full]'));
    var n = thumbs.length;
    if (!heroImg || n < 2) return;

    gallery.setAttribute('data-rm-swipe', '1');

    var alt = heroImg.getAttribute('alt') || '';
    var urls = thumbs.map(function (t) { return t.getAttribute('data-full'); });

    var track = document.createElement('div');
    track.className = 'rm-swipe-track';
    track.setAttribute('role', 'group');
    track.setAttribute('aria-label', 'Productafbeeldingen, veeg om te bladeren');

    function makeSlide(url, eager, clone) {
      var img = document.createElement('img');
      img.className = 'rm-swipe-slide';
      img.src = url;
      img.alt = clone ? '' : alt;
      if (clone) img.setAttribute('aria-hidden', 'true');
      img.setAttribute('loading', eager ? 'eager' : 'lazy');
      img.setAttribute('draggable', 'false');
      return img;
    }

    // Volgorde: [kloon laatste] [echte 0..n-1] [kloon eerste]
    // Posities:        0            1 .. n            n+1
    track.appendChild(makeSlide(urls[n - 1], false, true));
    urls.forEach(function (u, i) { track.appendChild(makeSlide(u, i === 0, false)); });
    track.appendChild(makeSlide(urls[0], false, true));

    hero.insertBefore(track, hero.firstChild);
    hero.classList.add('rm-has-swipe');

    function slideW() { return track.clientWidth || 1; }

    function setActive(realIdx) {
      for (var i = 0; i < n; i++) thumbs[i].classList.toggle('active', i === realIdx);
    }

    function posToReal(pos) {
      if (pos <= 0) return n - 1;
      if (pos >= n + 1) return 0;
      return pos - 1;
    }

    function goToReal(i, smooth) {
      var left = (i + 1) * slideW();
      if (smooth) {
        try { track.scrollTo({ left: left, behavior: 'smooth' }); return; }
        catch (e) {}
      }
      track.scrollLeft = left;
    }

    // Begin op de eerste echte foto (positie 1, niet op de kloon).
    function initPos() {
      if (slideW() <= 1) return;
      track.scrollLeft = slideW();
      setActive(0);
    }
    initPos();
    window.requestAnimationFrame(initPos);

    var raf = null, settleT = null;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var pos = Math.round(track.scrollLeft / slideW());
        setActive(posToReal(pos));
      });
      // Naadloze terugsprong zodra de swipe tot rust komt op een kloon.
      if (settleT) clearTimeout(settleT);
      settleT = setTimeout(function () {
        var w = slideW();
        var pos = Math.round(track.scrollLeft / w);
        if (pos <= 0) track.scrollLeft = n * w;          // kloon laatste -> echte laatste
        else if (pos >= n + 1) track.scrollLeft = w;     // kloon eerste  -> echte eerste
      }, 90);
    }, { passive: true });

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        goToReal(i, true);
        setActive(i);
      });
    });

    window.addEventListener('resize', function () {
      var active = 0;
      for (var i = 0; i < n; i++) {
        if (thumbs[i].classList.contains('active')) { active = i; break; }
      }
      goToReal(active, false);
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.gallery'), function (g) {
      build(g);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
